import { useMediaQuery, useTheme } from "@mui/material"
import React, { FC, Fragment, ReactElement } from "react"

import { Link } from "src/components/common/link"
import { create } from "src/helpers/bem"
import { GET_PAGE_page_meta_breadcrumb } from "src/types/wordpress/generated/GET_PAGE"

import styles from "./Breadcrumb.module.scss"

const bem = create(styles, "Breadcrumb")

export type BreadcrumbProps = {
  disabled?: boolean
  items?: (GET_PAGE_page_meta_breadcrumb | null)[] | null
}

export const Breadcrumb: FC<BreadcrumbProps> = ({ disabled, items }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("xl"))

  if (!items || items?.length <= 1 || disabled) {
    return null
  }

  const renderBreadcrumbPart = (
    item: GET_PAGE_page_meta_breadcrumb | null,
    isFirst: boolean,
    isLast: boolean,
  ): ReactElement => {
    const modified = {
      "is-active": isLast,
    }

    const renderLastPart = () =>
      !isMobile && <span className={bem("title", modified)}>{item?.title}</span>

    return (
      <>
        {!isFirst && !isMobile ? (
          <span className={bem("seperator")}>{">"}</span>
        ) : null}
        {(item?.path && !isMobile) || (item?.path && isMobile && isLast) ? (
          <Link
            href={item?.path ?? ""}
            classNames={{
              link: bem("link"),
              label: bem("title", modified),
            }}
          >
            {item?.title}
          </Link>
        ) : (
          renderLastPart()
        )}
      </>
    )
  }

  return (
    <div className={bem()}>
      {items.map((item, i) => {
        const isFirst = i === 0
        const isLast = i + 1 === items.length

        return (
          <Fragment key={item?.title}>
            {renderBreadcrumbPart(item, isFirst, isLast)}
          </Fragment>
        )
      })}
    </div>
  )
}
